import { when, linkify } from '../utils';
import type { Options } from './types';

const generator = ({
  email,
  address,
  phone,
  vat,
  commercialRegister,
  social,
  editor,
  video,
}: Options) => `
# Импрессум

## Отказ от ответственности

### Ответственность за контент
Мы стремимся тщательно следить за контентом на нашем сайте. Однако мы не можем гарантировать точность, полноту и актуальность контента. Как поставщики услуг, мы несем ответственность за собственный контент на страницах сайта, но не обязаны контролировать переданную или сохраненную чужую информацию или исследовать обстоятельства, указывающие на незаконную деятельность. Обязательства по удалению или блокированию информации в соответствии с общими законами остаются в силе. Однако ответственность за это возможна только с момента, когда становится известно о конкретном нарушении закона. При выявлении соответствующих нарушений мы немедленно удалим этот контент.


### Ответственность за ссылки
Наше предложение содержит ссылки на внешние веб-сайты третьих лиц, на содержание которых мы не имеем влияния. Поэтому мы не можем нести ответственность за чужой контент. Связанные страницы были проверены на предмет возможных юридических нарушений на момент размещения ссылок. На момент размещения ссылки незаконный контент не был обнаружен. Постоянный контроль содержания связанных страниц без конкретных указаний на правонарушение не представляется возможным. При выявлении нарушений мы немедленно удалим такие ссылки.

## Лицензии

Изображения, используемые на этом веб-сайте, являются свободными от лицензий, указание источника не требуется.


## Контактная информация

- **E-Mail**: [${email}](mailto:${email})
${when(address, `- **Почта:** ${address}`)}
${when(phone, `- **Телефон**: ${phone}`)}
${when(vat, `- **ИНН**: ${vat}`)}
${when(commercialRegister?.trim(), `
### Информация о компании
${commercialRegister}`)}
${when(social?.length, `

## Это уведомление также распространяется на следующие каналы в социальных сетях

${social?.map((item) => item.trim().length && `- ${linkify(item.trim())}`).filter(Boolean).join('\n')}`)}
${when(editor?.trim(), `

### Редакционно ответственный

${editor}`)}
${when(video?.trim(), `

### Надзорный орган для видеоконтента

${video}`)}
`.trim();

export default generator;
